<template>
	<div class="w-100">
    <transition name="fade">
      <div>
        <div class="bg-green rounded-6 px-4 py-4 mb-3">
          <p class="mb-3 body-2-2 font-bold text-18 text-white">{{$t("hotel.reservation-summary")}}</p>
          <template v-if="show_room">
            <div class="mb-3 p-3 bg-white rounded-4">
            <p class="mb-2 pb-1 body-2-2 text-12 text-black font-regular">{{$t('hotel.tap-to-see-detail')}}</p>
              <div class="w-100">
                <div class="row no-gutters mb-3" v-for="room_rate in getBeCart.room_rate_details">
                  <div class="col-3 pt-1" @click="onBack('detailRoom',room_rate)">
                    <div class="w-100" style="height: 74px;">
                      <img
                        v-if="room_rate.room_rate.room_type.image != ''"
                        :src="room_rate.room_rate.room_type.image[0].image_url" 
                        class="img-fit w-100 rounded-3 cursor-pointer">
                      <img
                        v-else
                        src="../../../../assets/img/icon/hotel-placeholder.svg" 
                        class="img-fit w-100 rounded-3 cursor-pointer">
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="ml-3">
                      <div class="row no-gutters">
                        <div class="col-10" @click="onBack('detailRoom',room_rate)">
                          <p class="w-100 mb-0 body-1-4 text-16 text-truncate cursor-pointer">{{room_rate.room_rate.name}}</p>
                          <template v-if="isRoomDiscount(room_rate)">
                            <p class="mb-0 body-3-3-1 text-line-through d-inline-block align-middle mr-2">{{formatCurrency(calculateSubTotal(room_rate,false))}}</p>
                            <p class="mb-0 body-2-2 text-12 font-semibold cursor-pointer d-inline-block align-middle">{{formatCurrency(calculateSubTotal(room_rate))}}</p>
                          </template>
                          <p v-else class="w-100 mb-0 body-2-2 text-12 font-semibold cursor-pointer">{{formatCurrency(calculateSubTotal(room_rate))}}</p>
                          <p class="mb-0 body-2-2 text-12 font-semibold position-relative cursor-pointer">
                            <img src="../../../../assets/img/icon/bed.png" width="10" class="d-inline-block mr-1 position-relative" style="top: -1px" />
                            <span>{{room_rate.qty}} {{$t('hotel.unit-type.'+room_rate.room_rate.room_type.type+'.unit')}}</span>
                          </p>
                          <p class="mb-0 body-2-2 text-12 font-semibold position-relative">
                            <img src="../../../../assets/img/icon/users.png" width="10" class="d-inline-block mr-1 position-relative" style="top: -1px" />
                            <span class="cursor-pointer">{{ filter_guest(room_rate.guest) }}</span>
                          </p>
                        </div>
                        <div class="col-2 text-right no-ws pt-1">
                          <i v-b-tooltip="`Adjust Pax`" class="simple-icon-pencil font-weight-bold text-16 text-green cursor-pointer d-inline-block align-middle mr-2" @click="onBack('adjustPax',room_rate)"></i>
                          <i v-b-tooltip="`Remove Room`" class="simple-icon-trash font-weight-bold text-16 text-danger cursor-pointer d-inline-block align-middle ml-1" @click="removeRoomRate(room_rate)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: -2px;">
                  <div class="row no-gutters">
                    <!-- <div class="col-12 mb-2">
                      <p class="mb-0 body-2-2 text-12 font-semibold text-truncate position-relative" style="top: 5px;"><img src="../../../../assets/img/icon/users.png" width="10" class="d-inline-block mr-2 position-relative" style="top: -2px" />{{filter_guest}}</p>
                    </div> -->
                    <div class="col-12">
                      <div class="row no-gutters">
                        <div class="col-6">
                          <p class="mb-1 body-2-2 text-12 font-semibold"><img src="../../../../assets/img/icon/calendar.png" width="10" class="d-inline-block mr-2 position-relative" style="top: -2px" />{{$t('hotel.date.check-in')}}</p>
                          <p class="mb-0 body-2-2 text-12 font-semibold"><img src="../../../../assets/img/icon/calendar.png" width="10" class="d-inline-block mr-2 position-relative" style="top: -2px" />{{$t('hotel.date.check-out')}}</p>
                        </div>
                        <div class="col-6 text-right">
                          <p class="mb-1 body-2-2 text-12 font-semibold">{{formatDate(getBeFilter.date.check_in)}}</p>
                          <p class="mb-0 body-2-2 text-12 font-semibold">{{formatDate(getBeFilter.date.check_out)}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isUnderSearchPax" class="w-100 p-3 text-center border mt-3" style="background-color: rgb(255, 246, 243); border-color: rgb(254, 207, 184) !important;">
                <p class="mb-0 body-2-1">{{isUnderSearchPax}}</p>
              </div>
            </div>
            <template>
              <ProductCart/>
            </template>
          </template>
          <div class="">
            <div class="row no-gutters">
              <div class="col-7">
                <p class="mb-1 body-2-2 text-white text-14 font-regular">{{getBeCart.qty.room_rate}} {{$t('hotel.unit-type.'+getBeRoomTypeSummaryType+'.unit')}} x {{totalDate}} {{$t("hotel.night")}}</p>
              </div>
              <div class="col-5 text-right">
                <p class="mb-1 body-2-2 text-white text-14 font-regular">{{formatCurrency(getBeRoomSubTotal)}}</p>
              </div>
              <template v-if="subtotalAdditionalService > 0">
                <div class="col-7">
                  <p class="mb-1 body-2-2 text-white text-14 font-regular">{{ `${$t('hotel.additional-service')}${totalTaxServiceAdditional > 0 ? '(Incl. Tax)' : ''}` }}</p>
                </div>
                <div class="col-5 text-right">
                  <p class="mb-1 body-2-2 text-white text-14 font-regular">{{formatCurrency(subtotalAdditionalService)}}</p>
                </div>
              </template>
              <div class="col-7 pt-2 my-2 border-light-top">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{$t('hotel.concierge.discount')}}</p>
              </div>
              <div class="col-5 text-right pt-2 my-2 border-light-top">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{ `${totalDiscount > 0 ? '-' : ''}${$formatCurrency(totalDiscount)}` }}</p>
              </div>
              <div class="col-7 pb-2 mb-2 border-light-bottom">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{$t('hotel.total-price')}}</p>
              </div>
              <div class="col-5 text-right pb-2 mb-2 border-light-bottom">
                <p class="mb-0 body-2-2 text-white text-14 font-regular">{{formatCurrency(total_price)}}</p>
              </div>
              <div class="col-12">
                <div class="row">
                  <template v-if="payment_surcharge > 0">
                    <div class="col-7">
                      <p class="mb-1 body-2-2 text-white text-14 font-regular">{{$t('hotel.payment-surcharge')}}</p>
                    </div>
                    <div class="col-5 text-right">
                      <p class="mb-1 body-2-2 text-white text-14 font-regular">{{formatCurrency(payment_surcharge)}}</p>
                    </div>
                  </template>
                  <div class="col-7">
                    <p class="mb-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display > 0}">{{$t('hotel.deposit-due-now')}} <template v-if="total_deposit_merchant > 0">({{ getMerchant.deposit_zero_minimum_deposit_value }}%)</template></p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display > 0}">{{formatCurrency(total_deposite_display)}}</p>
                  </div>
                  <div class="col-7">
                    <p class="mb-1 pb-1 mt-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display == 0}">{{$t('hotel.deposit-due-on-arrival')}}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-1 pb-1 mt-1 body-2-2 text-white text-14" :class="{'font-bold text-16':total_deposite_display == 0}">{{formatCurrency(total_non_deposit)}}</p>
                  </div>
                </div>  
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="bg-white box-shadow-main rounded-6 px-4 py-4 mb-3" v-if="cart_step == 2 && this.getMerchant.use_changeable_deposit_value">
          <CustomDeposit :minimum_deposit="minimum_all_deposit" :total_order="total_price"></CustomDeposit>
        </div> -->
      </div>
    </transition>
	</div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex'
  import {formatCurrency,formatDate} from '@/utils/index.js'
  import moment from 'moment';
  import CustomDeposit from '@/components/hotel/be/CustomDeposit'
  import ProductCart from '../additionalService/ProductCart';

	export default{
    props:{
      show_room: {
        type: Boolean,
        default: true
      },
      payment_surcharge:{
        type: Number,
        default: 0
      },
      payment_method:{
        type: Object,
        default: () => {}
      },
      total_deposit_merchant:{
        type: Number,
        default: 0
      },
      cart_step:{
        type: Number,
        default: 1
      }
    },
    components:{
      CustomDeposit,
      ProductCart
    },
    data(){
      return{
        data_room: ''
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getBeCartAddtService',
        'getBeCart',
        'getBeFilter',
        'getBeRoomSubTotal',
        'getBeRoomDeposit',
        'getBeAddtServiceDeposit',
        'getBeAddtServiceSubTotal',
        'getBeRoomTotal',
        'getBeRoomDiscount',
        'getBeRoomTypeSummaryType',
        'getActivityTrxTotal',
        'getOutletTrxTotal',
        'getVoucherOrderTotal',
        'isUnderSearchPax',
        'getActivityTrxSubTotal',
        'getOutletTrxSubTotal',
        'getVoucherOrderSubTotal',
        'getActivityTrxPromotion',
        'getOutletTrxPromotion',
        'getVoucherOrderTotalPromo',
        'getActivityTrxTaxService',
        'getOutletTrxTaxService'
      ]),
      totalTaxServiceAdditional(){
        return Number(this.getActivityTrxTaxService) + Number(this.getOutletTrxTaxService)
      },
      subtotalAdditionalService(){
        const subTotal = this.getBeAddtServiceSubTotal + Number(this.getActivityTrxSubTotal) + Number(this.getOutletTrxSubTotal) + Number(this.getVoucherOrderSubTotal)
        
        return subTotal + this.totalTaxServiceAdditional;
      },
      promotionAdditionalService() {
        return (
          Number(this.getActivityTrxPromotion) +
          Number(this.getOutletTrxPromotion) +
          Number(this.getVoucherOrderTotalPromo)
        );
      },
      totalDiscount(){
        return Number(this.getBeRoomDiscount) + Number(this.promotionAdditionalService);
      },  
      taxAdditionalService() {
        return (
          Number(this.getActivityTrxTaxService) +
          Number(this.getOutletTrxTaxService)
        );
      },
      total_additional_service(){
        let total = this.getBeAddtServiceSubTotal+this.$totalAddtServiceModule()
        return total
      },
      total_price(){
        return this.getBeRoomTotal+this.total_additional_service
      },
      total_deposit(){
        let total = this.getBeRoomDeposit+this.getBeAddtServiceDeposit+this.$totalAddtServiceModule()
        if(Object.keys(this.payment_method).length > 0 && this.payment_method.bank_name == 'XENDIT' && this.payment_method.payment_method == 'CREDIT_CARD'){
          return Math.ceil(total)
        }
        return total
      },
      total_deposite_display(){
        let total = this.total_deposit_merchant > 0 ? this.total_deposit_merchant : this.total_deposit
        if(this.payment_surcharge > 0){
          total += this.payment_surcharge
        }
        return total
      },
      minimum_all_deposit(){
        if(this.total_deposit == 0){
          return this.total_deposit_merchant
        }else{
          return this.total_deposit < this.total_deposit_merchant ? this.total_deposit : this.total_deposit_merchant
        }
      },
      total_non_deposit(){
        let deposit = this.total_deposit_merchant > 0 ? this.total_deposit_merchant : this.total_deposit
        let total = this.total_price-deposit
        if(Object.keys(this.payment_method).length > 0 && this.payment_method.bank_name == 'XENDIT' && this.payment_method.payment_method == 'CREDIT_CARD'){
          return Math.ceil(total)
        }
        return total
      },
      totalDate() {
        var diff = 0
        let check_in = moment(this.getBeFilter.date.check_in).format("YYYY-MM-DD")
        let check_out = moment(this.getBeFilter.date.check_out).format("YYYY-MM-DD")
        diff = moment(check_out).diff(moment(check_in)) / (1000 * 3600 * 24)
        return diff
      },
    },
    methods:{
      ...mapMutations(['beRemoveRoomRate','changeBeRoomAvbl','BeRemoveAddtService']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      formatDate(date){
        return formatDate(date);
      },
      calculateSubTotal(data,with_discount=true){
        let total = 0
        for(let i=0 ; i < data.qty; i++){
          for(let date of data.room_rate.dates){
            let total_extra = {
              adult: data.guest[i].extra.adult*date.extra_guest.adult.amount,
              child: data.guest[i].extra.child*date.extra_guest.child.amount,
              infant: data.guest[i].extra.infant*date.extra_guest.infant.amount,
            }
            let total_extra_price = total_extra.adult+total_extra.child+total_extra.infant
            let base_price = with_discount ? date.price+date.promotion_price : date.price
            if(total_extra_price > 0){
              total += (base_price+total_extra_price)
            }else{
              total += base_price
            }
          }
        }
        return total
      },
      isRoomDiscount(data){
        let total = 0
        for(let date of data.room_rate.dates){
          total += date.promotion_price
        }
        return total < 0
      },
      onBack(type, data){
        this.$emit(type, data)
      },
      removeRoomRate(cart){
        this.beRemoveRoomRate(cart.room_rate.id);
        let roomtype_params = {
          id: cart.room_rate.room_type.id,
          rr_id: cart.room_rate.id,
          qty: cart.qty,
          action: 'inc',
          is_virtual: cart.room_rate.room_type.is_virtual,
          availability_affected: cart.room_rate.room_type.availability_affected
        }
        this.changeBeRoomAvbl(roomtype_params);
      },
      filter_guest(room_rate){
        let total_guest = {
          adult: 0,
          child: 0,
          infant: 0,
          extra: 0
        }
        room_rate.forEach(item=>{
          total_guest.adult += item.included.adult
          total_guest.child += item.included.child
          total_guest.infant += item.included.infant
          total_guest.extra += (item.extra.adult+item.extra.child+item.extra.infant)
        })
        let container = []
        if(total_guest.adult > 0){
          container.push(total_guest.adult+' '+ this.$t('hotel.adults.adults'))
        }
        if(total_guest.child > 0){
          container.push(total_guest.child+' '+ this.$t('hotel.children.children'))
        }
        if(total_guest.infant > 0){
          container.push(total_guest.infant+' '+ this.$t('hotel.infants.infants'))
        }
        if(total_guest.extra > 0){
          container.push(`${total_guest.extra} ${this.$pluralWord(total_guest.extra,this.$t('hotel.extra-guest'))}`)
        }

        let display = ''
        for(let i = 0; i < container.length; i++){
          if((i+1) == container.length){
            display += container[i]
          }else{
            display += (container[i]+', ')
          }
        }

        return display
      },
      removeAddtService(product){
        this.BeRemoveAddtService(product)
      }
    },
	}
</script>
<style scoped>
  @media screen and (max-width: 1050px) {
    .text-14{
      font-size: 12px!important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/cart.vue